<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'EditBanner',
  mixins: [baseMixin],
  props: {
    editDescription: { type: String, default: '' },
  },
}
</script>

<template>
  <v-alert
    height="45"
    class="edit-banner"
    icon="mdi-alert-circle-outline"
    text
    type="info"
  >
    {{ editDescription }}
  </v-alert>
</template>

<style lang="scss" scoped>
.v-alert--text::before {
  background-color: unset !important;
}
</style>
